module.exports = __webpack_public_path__ + "static/img/img_03.1a7f706.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/img_03.jpg
// module id = ut7j
// module chunks = 98